import React from 'react';
import { Badge } from 'reactstrap';
import { getDateAndTime } from '../../helpers/inbdeUtils';
import PastRandomSetsTableRowActions from '../../components/randomSets/PastRandomSetsTableRowActions';
import RandomSetFilters from '../../components/randomSets/RandomSetFilters';
import { exportFormatOptions, exportFormats } from '../content/exportFormats';

const formatColors = {
  [exportFormats.csv]: 'info',
  [exportFormats.rtf]: 'primary'
};

const actionFormatter = (dataField, { path, url }) => <PastRandomSetsTableRowActions path={path} url={url} />;

const filterFormatter = (filters, { keywords }) => <RandomSetFilters filters={filters} keywords={keywords} />;

// the format is what decides whether an archive is any use to whoever downloads
// it, so it says what it is for rather than only naming the file type
const formatFormatter = format => {
  const option = exportFormatOptions.find(exportFormatOption => exportFormatOption.value === format);

  return (
    <>
      <Badge color={'soft-' + (formatColors[format] || 'secondary')} className="rounded-capsule fs--1">
        {option ? option.label : format}
      </Badge>
      {option && <div className="fs--2 text-600 mt-1">{option.description}</div>}
    </>
  );
};

const questionCountFormatter = count => <span>{count + (count === 1 ? ' question' : ' questions')}</span>;

const timeFormatter = time => <span>{getDateAndTime(time)}</span>;

export const columns = [
  {
    dataField: 'name',
    text: 'Set Name',
    sort: true,
    classes: 'align-middle max-vw-20 text-wrap text-break'
  },
  {
    dataField: 'question_count',
    text: 'Questions',
    sort: true,
    formatter: questionCountFormatter,
    classes: 'align-middle text-nowrap pl-2 pr-2'
  },
  {
    dataField: 'format',
    text: 'Format',
    sort: true,
    formatter: formatFormatter,
    classes: 'align-middle pl-2 pr-2'
  },
  {
    dataField: 'created_by.displayName',
    text: 'Created By',
    sort: true,
    classes: 'align-middle text-truncate pl-2 pr-2'
  },
  {
    dataField: 'created_at',
    text: 'Created At',
    sort: true,
    formatter: timeFormatter,
    classes: 'align-middle text-truncate pl-2 pr-2'
  },
  {
    dataField: 'filters',
    text: 'Filters',
    formatter: filterFormatter,
    classes: 'align-middle max-vw-20 text-wrap text-break'
  },
  {
    dataField: 'action',
    text: 'Actions',
    formatter: actionFormatter,
    classes: 'align-middle'
  }
];
